import FaqDrawerList, { FaqDrawerListProps } from '@/components/_rebrand/FaqDrawerList';
import { parseHtml } from '@/lib/parse-html';
import Link from 'next/link';

const displayProps = {
  title: 'Frequently asked questions',
  description: (
    <p className="text-p2 md:text-p1 text-gray-700 rich-text">
      Can’t find the answer here? Our <Link href="https://help.front.com/en/contact-us" target="_blank" style={{ textDecoration: 'underline' }}>support team</Link> is happy to help.
    </p>
  ),
  drawers: [],
  darkBackground: false,
  styleOverrides: undefined,
} as FaqDrawerListProps;


type FaqItemFromCraft = {
  question: string;
  answer: string;
}

const formFaqItems = (items: FaqItemFromCraft[]): FaqDrawerListProps['drawers'] => {
  const drawers: FaqDrawerListProps['drawers'] = items.map((item) => ({
    question: item.question,
    answer: parseHtml(item.answer)
  }));

  return drawers;
}

const setDynamicDisplayPropAttributes = (data: FaqItemFromCraft[]) => {
  displayProps.drawers = formFaqItems(data);
};

const FAQ = ({ entry }) => {
  const isDynamicRebrandModule = (entry.__typename && entry.__typename == 'comparisonModules_faq_BlockType');

  const data = (isDynamicRebrandModule) ? entry.items : entry?.moduleProductFaq;

  setDynamicDisplayPropAttributes(data);

  // we are confident entry exists for any isDynamicRebrandModule as it would not be called.
  if (isDynamicRebrandModule) {
    displayProps.title = (entry.headline && entry.headline.length) ? entry.headline : displayProps.title;
    displayProps.description = (entry.description && entry.description.length) ? parseHtml(entry.description) : displayProps.description;
    displayProps.styleOverrides = {
      bottomMarginSpacing: 'none',
      topMarginSpacing: 'none'
    };
  }

  return (
    <FaqDrawerList {...displayProps} />
  );
};

export default FAQ;
